import { ChatsChannelType } from '../../constants/types';

const ICON_BASE_URL = 'https://static.elfsight.com/icons/';

const CHAT_ICON = {
  [ChatsChannelType.whatsapp]: `${ICON_BASE_URL}app-chats-whatsapp-chat-multicolor.svg`,
  [ChatsChannelType.telegram]: `${ICON_BASE_URL}app-chats-telegram-chat.svg`,
  [ChatsChannelType.instagram]: `${ICON_BASE_URL}instagram.svg`,
  [ChatsChannelType.wechat]: `${ICON_BASE_URL}chats-wechat-chat.svg`,
  [ChatsChannelType.viber]: `${ICON_BASE_URL}app-chats-viber.svg`,
  [ChatsChannelType.line]: `${ICON_BASE_URL}line.svg`,
  [ChatsChannelType.discord]: `${ICON_BASE_URL}discord.svg`,
  [ChatsChannelType.facebook]: `${ICON_BASE_URL}facebook-messenger.svg`,
  [ChatsChannelType.rumbletalk]: `${ICON_BASE_URL}rumbletalk.svg`,
  [ChatsChannelType.call]: `${ICON_BASE_URL}phone.svg`,
  [ChatsChannelType.email]: `${ICON_BASE_URL}email.svg`,
  [ChatsChannelType.getdirection]: `${ICON_BASE_URL}directions.svg`,
  [ChatsChannelType.kakaotalk]: `${ICON_BASE_URL}app-chats-kakao-talk.svg`,
  [ChatsChannelType.googlemaps]: `${ICON_BASE_URL}location.svg`,
  [ChatsChannelType.savecontact]: `${ICON_BASE_URL}floating-button-invite.svg`,
  [ChatsChannelType.sms]: `${ICON_BASE_URL}app-chats-message.svg`,
  [ChatsChannelType.snapchat]: `${ICON_BASE_URL}snapchat.svg`,
  [ChatsChannelType.twitter]: `${ICON_BASE_URL}twitter-x.svg`,
  [ChatsChannelType.custom]: '',
  sendMessage: `${ICON_BASE_URL}app-chats-send-message.svg`
};

export const getChatIcon = (
  provider: ChatsChannelType | 'sendMessage',
  customSource?: string
) => {
  return { url: customSource || CHAT_ICON[provider] };
};
